import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative w-full" data-id="element-248">
      {/* Hero Image Background */}
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-249">
        <img src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1920&q=80" alt="Beautiful residential property" className="w-full h-full object-cover blur-[2px] scale-105" data-id="element-250" />
        <div className="absolute inset-0 bg-gradient-to-br from-[oklch(0.18_0.07_250/0.93)] via-[oklch(0.22_0.06_250/0.85)] to-[oklch(0.28_0.04_240/0.60)]" data-id="element-251" />
      </div>

      {/* Valley shape divider */}
      <div className="absolute bottom-0 left-0 right-0 z-[5]" data-id="element-252">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-[30px] md:h-[40px] lg:h-[50px]" preserveAspectRatio="none" data-id="element-253">
          <path d="M0 0C0 0 360 60 720 60C1080 60 1440 0 1440 0V60H0V0Z" fill="white" data-id="element-254" />
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 pt-16 pb-28 md:pt-24 md:pb-36 lg:pt-32 lg:pb-40" data-id="element-255">
        <div className="max-w-3xl" data-id="element-256">
          {/* Trust badge */}
          <div className="hero-animate inline-flex items-center gap-2 bg-white/12 backdrop-blur-md border border-white/15 rounded-full px-5 py-2.5 mb-7" style={{
          animationDelay: '0.1s'
        }} data-id="element-257">
            <div className="w-2 h-2 rounded-full bg-[oklch(0.82_0.18_85)] animate-pulse" data-id="element-258" />
            <span className="text-white/90 text-sm font-medium tracking-wide" data-id="element-259">
              Serving Fresno for Over 40 Years
            </span>
          </div>

          <h1 className="hero-animate font-heading text-4xl md:text-5xl lg:text-6xl font-medium text-white tracking-tight mb-5 leading-[1.1]" style={{
          animationDelay: '0.25s'
        }} data-id="element-260">
            Trusted Property
            <br data-id="element-261" />
            Management in
            <br data-id="element-262" />
            <span className="text-white" data-id="element-263">Fresno</span>
          </h1>

          <p className="hero-animate text-lg md:text-xl text-white/80 max-w-xl mb-8 leading-relaxed" style={{
          animationDelay: '0.4s'
        }} data-id="element-264">
            We help property owners maximize their investments while providing
            quality homes for families across the Central Valley.
          </p>

          <div className="hero-animate flex flex-col sm:flex-row items-start gap-4" style={{
          animationDelay: '0.55s'
        }} data-id="element-265">
            <Button className="px-10 py-5 h-auto text-lg font-medium bg-[oklch(0.45_0.16_250)] text-white hover:bg-[oklch(0.40_0.16_250)] hover:text-white shadow-lg rounded-xl" data-id="element-266">
              Browse Properties
              <ChevronRight className="h-5 w-5 ml-2" data-id="element-267" />
            </Button>
            <Button variant="outline" className="px-10 py-5 h-auto text-lg font-medium border-2 border-white/40 text-white hover:bg-white/10 hover:border-white/60 hover:text-white bg-white/5 backdrop-blur-sm rounded-xl" data-id="element-268">
              Owner Services
            </Button>
          </div>
        </div>
      </div>
    </section>;
}